<template>
  <v-switch v-model="DarkMode" color="primary" @change="toggleTheme">
    <template v-slot:label>
      <v-icon v-if="DarkMode">{{ darkIcon }}</v-icon>
      <v-icon v-else>{{ lightIcon }}</v-icon>
    </template>
  </v-switch>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { EventBus } from "@/code/event-bus";

let stored = localStorage.getItem("DarkMode");
if (stored === null) {
  localStorage.setItem("DarkMode", "true");
  stored = "true";
}
const DarkMode = ref(stored === "true");

const lightIcon = "mdi-weather-sunny";
const darkIcon = "mdi-weather-night";

const applyTheme = () => {
  EventBus.emit("themeChange", { message: DarkMode.value });
};

const toggleTheme = () => {
  localStorage.setItem("DarkMode", DarkMode.value.toString());
  applyTheme();
};

onMounted(() => {
  applyTheme();
});
</script>
